import React from 'react';

import {
  MidContainer,
  SponsorContainer,
  SponsorDisclaimer,
  SponsorLink,
  SponsorLogoContainer,
  SponsorLogo,
} from './styles';

export default function SponsorDisplay({ sponsor, contest }) {
  const renderJobAd = () => (
    <MidContainer>
      <SponsorContainer title={`Ad: ${sponsor.adText}`}>
        <SponsorDisclaimer>Ad:</SponsorDisclaimer>
        <SponsorLink target="_blank" rel="noopener noreferrer" href={sponsor.adTextLink}>
          {sponsor.adText}
        </SponsorLink>
      </SponsorContainer>
    </MidContainer>
  );

  const renderContestSponsor = () =>
    contest && (
      <MidContainer>
        <SponsorLogoContainer>
          <SponsorLogo src={contest.contestLogo || contest.landingPageLogo} alt="Sponsor" />
        </SponsorLogoContainer>
      </MidContainer>
    );

  return sponsor.adText ? renderJobAd() : renderContestSponsor();
}
